<template>
  <div class="px-3" v-resize="onResize">
    <v-row class="px-3">
      <v-col cols="12" md="6" class="pl-0">
        <h1 class="py-md-3">
          {{ $t("viewCustomers.title") }}
          <v-btn
            color="success"
            class="ml-1 green-shadow"
            x-small
            fab
            max-width="26"
            max-height="26"
            @click="addCustomer()"
            :disabled="!fetched"
            :loading="!fetched"
            :title="$t('common.add')"
            id="createCustomer"
          >
            <v-icon x-small>$plus</v-icon>
          </v-btn>
        </h1>
      </v-col>
      <v-col cols="12" md="4" align-self="end" class="d-flex justify-end px-0">
        <v-text-field
          id="help-step-1"
          outlined
          :placeholder="$t('viewCustomers.search_placeholder')"
          append-icon="fa-times"
          hide-details
          @click:append="search = ''"
          v-model="search"
          class="mb-2 text-field-bg d-none"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="2" align-self="end" class="d-flex justify-end px-0">
        <v-select
          id="help-step-2"
          outlined
          class="mb-2 ml-md-5 mr-md-4 select-on-transparent"
          v-if="customerTypes.length > 0"
          :items="customerTypes"
          :label="$t('common.customer_type')"
          item-text="name"
          item-value="id"
          v-model="customerTypeFilter"
          append-icon="fa-times"
          hide-details
          @click:append="customerTypeFilter = null"
        ></v-select>
      </v-col>
    </v-row>
    <v-data-table
      :headers="customersTableHeader"
      :items="filtedredCustomers"
      :page.sync="tablePage"
      class="elevation-0 mb-3"
      :height="tableHeight"
      ref="customersTable"
      :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:[lastHeaderElement]="props">
        {{ props.header.text }}
        <table-config-btn :table="tableName" :default-columns="defaultCustomersTableHeader"/>
      </template>
      <template v-slot:item.human_number="props">
        <span
            @click="
              customerId = props.item.id;
              customerEditForm = true;
              customerFormTabsId = 0;
            "
        >
          {{ props.item.human_number }}
        </span>
      </template>
      <template v-slot:item.last_name="props">
        {{ props.item.last_name }} {{ props.item.first_name }}
        {{ props.item.patronymic }}
        {{
          props.item.is_company == 1
              ? "[" + props.item.legal_name + "]"
              : ""
        }}
      </template>
      <template v-slot:item.comment="props">
        {{ props.item.comment }}
      </template>
      <template v-slot:item.phone="props">
        {{ props.item.phone }}
      </template>
      <template v-slot:item.email="props">
        {{ props.item.email }}
      </template>
      <template v-slot:item.address="props">
        {{ props.item.postal_code }}, {{ props.item.address }}
      </template>
      <template v-slot:item.created_at="props">
        {{ props.item.created_at | moment("DD.MM.YYYY") }}
        <br/>
        {{ props.item.created_at | moment("HH:mm") }}
      </template>
      <template v-slot:item.actions="props">
        <div class="text-right" style="min-width: 280px">
         <span class="btn-td-wrap">
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  class="mb-0 ml-3 px-0 white--text"
                  color="success"
                  :title="$t('common.creating_order')"
                  :disabled="cartIsLoading"
                  @click="goToSearchWithCustomer(props.item)"
              >
                <v-icon small>$cart</v-icon>
              </v-btn>

              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  color="primary"
                  class="mb-0 ml-3 px-0 white--text"
                  @click="
                  customerId = props.item.id;
                  customerEditForm = true;
                  customerFormTabsId = 0;
                "
                  :title="$t('common.edit')"
              >
                <v-icon small>$pencil</v-icon>
              </v-btn>
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  @click="
                  $store.dispatch('customers/remove', {
                    id: props.item.id,
                  })
                "
                  color="red lighten-2"
                  class="mb-0 ml-3 px-0 white--text"
                  :title="$t('common.remove')"
              >
                <v-icon small>$trash</v-icon>
              </v-btn>
            </span>
        </div>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
    <v-dialog v-model="customerEditForm" scrollable max-width="890">
      <customerForm
        @removed="customerEditForm=false"
        :is-visible="customerEditForm"
        @update="$store.dispatch('customers/get');"
        @store="
          (data) => {
            $store.dispatch('customers/get');
            customerId = data.id;
            customerEditForm = false;
            customerEditForm = true;
          }
        "
        :customer-id="customerId"
      ></customerForm>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import CustomerForm from "@/components/customer/CustomerForm.vue";
import CommonMixin from "@/mixins/common";
import RightsMixin from "@/mixins/rights";
import TableConfigBtn from "@/components/common/TableConfigBtn";
export default {
  components: {TableConfigBtn, CustomerForm },
  data: () => ({
    tablePage: 1,
    tableName: "customers",
    customerId: null,
    customerEditForm: false,
    customerTypeFilter: null,
    search: "",
    tableHeight: "100",
  }),
  mixins: [CommonMixin, RightsMixin],
  mounted() {
    this.$store.dispatch("tables_config/get").then(()=> {
      this.$store.dispatch("customers/get");
      this.$store.dispatch("customer_types/get");
    });
    this.helpcallbacks = {
      onNextStep: this.myCustomNextStepCallback,
    };
    this.helpsteps = this.createCustomerAndOrderHelpSteps;
  },
  computed: {
    lastHeaderElement(){
      return 'header.'+(this.customersTableHeader.slice(-1) && this.customersTableHeader.slice(-1)[0] && this.customersTableHeader.slice(-1)[0].value);
    },
    createCustomerAndOrderHelpSteps(){
      let result = [
        {
          target: "#createCustomer", // We're using document.querySelector() under the hood
          content: this.$t("help.create_customer"),
          params: {
            placement: 'left'
          },
        },
        {
          target: "#saveCustomer",
          content: this.$t("help.create_customer"),
          before: (type) =>
              new Promise((resolve, reject) => {
                let isFormOpened = document.getElementById("customerForm");
                if (isFormOpened && this.customerEditForm) {
                  resolve();
                }
              }),
        },
        {
          target: "#garageTab",
          content: this.$t("help.go_to_garage"),
          before: (type) =>
              new Promise((resolve, reject) => {
                let hasGarageTab = document.getElementById("garageTab");
                if (hasGarageTab && this.customerEditForm) {
                  resolve();
                }
              }),
        },
        {
          target: "#newCarBtn",
          content: this.$t("help.create_car"),
          before: (type) =>
              new Promise((resolve, reject) => {
                let hasNewCarBtn = document.getElementById("newCarBtn");
                if (hasNewCarBtn && this.customerEditForm) {
                  resolve();
                }
              }),
        },
        {
          target: "#placeholderAddCar",
          content: this.$t("help.choose_car_by_parameters"),
          before: (type) =>
              new Promise((resolve, reject) => {
                let hasPlaceholderAddCar =
                    document.getElementById("placeholderAddCar");
                let isVisibleBrandsLevam = document.getElementById("brandsLevam");
                if (
                    hasPlaceholderAddCar &&
                    isVisibleBrandsLevam &&
                    this.customerEditForm
                ) {
                  resolve();
                }
              }),
        },
        {
          target: "#saveCarBtnPlaceholder",
          content: this.$t("help.save_car"),
          before: (type) =>
              new Promise((resolve, reject) => {
                let hasSaveCarBtn = document.getElementById("saveCarBtn");
                if (hasSaveCarBtn && this.customerEditForm) {
                  resolve();
                }
              }),
        },
        {
          target: "#toOEMBtn",
          content: this.$t("help.go_to_catalog"),
          before: (type) =>
              new Promise((resolve, reject) => {
                let hasSaveCarBtn = document.getElementById("toOEMBtn");
                if (hasSaveCarBtn) {
                  resolve();
                }
              }),
        },
        {
          target: "#displayframeOEM",
          content: this.$t("help.choose_part"),
          before: (type) =>
              new Promise((resolve, reject) => {
                let hasElement = document.getElementById("displayframeOEM");
                if (hasElement) {
                  resolve();
                }
              }),
        },
        {
          target: "#cartCounter",
          content: this.$t("help.press_cart_icon"),
          before: (type) =>
              new Promise((resolve, reject) => {
                let hasCartCounter = document.getElementById("cartCounter");
                if (hasCartCounter) {
                  resolve();
                }
              }),
        },
        {
          target: "#goToSearchWithPart",
          content: this.$t("help.press_get_price"),
          before: (type) =>
              new Promise((resolve, reject) => {

                let hasGoToSearchWithPartBtn = document.getElementById("goToSearchWithPart");
                let isVisibleCart = document.getElementById("cartVisibilityPlaceholder");
                if (hasGoToSearchWithPartBtn && isVisibleCart) {
                  resolve();
                }

              }),
        },
        {
          target: "#partsSearchResult",
          content: this.$t("help.parts_search_result"),
          params: {
            placement: 'top'
          },
          before: (type) =>
              new Promise((resolve, reject) => {
                let isHasBlockWithResults = document.getElementById("partsSearchResult");
                if (isHasBlockWithResults) {
                  resolve();
                }

              }),
        },
        {
          target: "#addToOrder",
          content: this.$t("help.press_add_to_order"),
          before: (type) =>
              new Promise((resolve, reject) => {
                let isHasAddToOrderBtn = document.getElementById("addToOrder");
                if (isHasAddToOrderBtn) {
                  resolve();
                }

              }),
        },
      ];
      if(this.tarrifplanHasAbility('parts_and_repairtimes')){
        result.push(
          {
            target: "#searchRepairtimesTab",
            content: this.$t("help.go_to_add_works_to_order"),
            params: {
              placement: 'top'
            },
            before: (type) =>
                new Promise((resolve, reject) => {
                  let isCartSumMoreThanZero = document.getElementById("isCartSumMoreThanZeroPlaceholder");
                  if (isCartSumMoreThanZero) {
                    resolve();
                  }

                }),
          });
        result.push({
            target: "#repairtimesTree",
            content: this.$t("help.add_works_to_cart"),
            params: {
              placement: 'top'
            },
            before: (type) =>
                new Promise((resolve, reject) => {
                  let hasRepairtimesTree = document.getElementById("repairtimesTree");
                  if (hasRepairtimesTree) {
                    resolve();
                  }

                }),
          }
        )
      }
      result.push(
        {
          target: "#checkoutOrderBtn",
          content: this.$t("help.checkout_order"),
          before: (type) =>
              new Promise((resolve, reject) => {

                let isCartSumMoreThanZero = document.getElementById("isCartSumMoreThanZeroPlaceholder");
                let hasCartRepairtimes = document.getElementById("hasCartRepairtimesPlaceholder");
                let check = this.tarrifplanHasAbility('parts_and_repairtimes') ? (hasCartRepairtimes && isCartSumMoreThanZero) : isCartSumMoreThanZero
                if (check) {
                  resolve();
                }

              }),
        });
      if(this.tarrifplanHasAbility('parts_and_repairtimes')) {
        result.push(
            {
              target: "#datesInCalendarBtn",
              content: this.$t("help.add_work_to_calendar"),
              before: (type) =>
                  new Promise((resolve, reject) => {

                    let isDatesInCalendarBtn = document.getElementById("datesInCalendarBtn");
                    if (isDatesInCalendarBtn) {
                      resolve();
                    }

                  }),
            });
        result.push(
            {
              target: "#dragToCalendarForAttachingPlaceholder",
              content: this.$t("help.drag_to_calendar_for_attaching"),
              params: {
                placement: 'top'
              },
              before: (type) =>
                  new Promise((resolve, reject) => {
                    let dragToCalendarForAttachingPlaceholder = document.getElementById("dragToCalendarForAttachingPlaceholder");
                    if (dragToCalendarForAttachingPlaceholder) {
                      resolve();
                    }

                  }),
            });
        result.push(
            {
              target: "#saveIntervalsBtn",
              content: this.$t("help.save_intervals"),
              before: (type) =>
                  new Promise((resolve, reject) => {

                    let hasRepairtimesWithIntervals = document.getElementById("hasRepairtimesWithIntervals");

                    if (hasRepairtimesWithIntervals) {
                      resolve();
                    }

                  }),
            });
      }
      result.push(
        {
          target: "#orderTitle",
          content: this.$t("help.order_is_created"),
          before: (type) =>
              new Promise((resolve, reject) => {

                let hasRepairtimesWithIntervals = document.getElementById("orderTitle");
                let dragToCalendarForAttachingPlaceholder = document.getElementById("dragToCalendarForAttachingPlaceholder");
                if (hasRepairtimesWithIntervals&& !dragToCalendarForAttachingPlaceholder) {
                  resolve();
                }

              }),
        });
      return result;
    },
    ...mapFields("cart", ["cartIsLoading", "carts"]),
    ...mapFields("customers", [
      "customer",
      "customers",
      "fetched",
      "customerFormTabsId",
    ]),
    ...mapFields("customer_types", ["customerTypes"]),
    filtedredCustomers() {
      return this.customers.filter((item) => {
        let search = false;
        search =
          item.last_name.toUpperCase().indexOf(this.search.toUpperCase()) !=
            -1 ||
          (item.patronymic &&
            item.patronymic.toUpperCase().indexOf(this.search.toUpperCase()) !=
              -1) ||
          item.first_name.toUpperCase().indexOf(this.search.toUpperCase()) !=
            -1 ||
          (item.legal_name &&
            item.legal_name.toUpperCase().indexOf(this.search.toUpperCase()) !=
              -1) ||
          item.phone.indexOf(this.search) != -1;

        if (search) {
          if (this.customerTypeFilter === null) return search;
          if (Number(this.customerTypeFilter) === Number(item.customer_type_id))
            return true;
        }
        return false;
      });
    },
    customersTableHeader(){
      let tableHeaderConfig =  this.getConfiguredTableHeader(this.tableName, this.defaultCustomersTableHeader);
      return tableHeaderConfig.filter(item=>item.is_hidden!==true)
    },
    defaultCustomersTableHeader() {
      return [
        {
          text: this.$t("viewCustomers.tableHeader.human_number"),
          value: "human_number",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.customer"),
          value: "last_name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.comment"),
          value: "comment",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.phone"),
          value: "phone",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.email"),
          value: "email",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.address"),
          value: "address",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewCustomers.tableHeader.created_at"),
          value: "created_at",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: "",
          sortable: false,
          class: "text-no-wrap flex-nowrap justify-space-between",
          is_action_column: true,
          value: "actions"
        },
      ];
    },
  },
  methods: {
    addCustomer() {
      this.customer = {};
      this.customerId = null;
      this.customerEditForm = true;
    },
    myCustomNextStepCallback(currentStep) {},
    onResize() {
      this.setTableHeight();
    },
    setTableHeight() {
      let rect = this.$refs["customersTable"].$el.getBoundingClientRect();
      if (rect) {
        this.tableHeight = window.innerHeight - rect.top - 90;
      }
    },
  },
  watch: {
    customerTypeFilter(value){
      //console.log(value)
      this.tablePage = 1;
    },
    fetched() {
      this.$nextTick(() => {
        this.setTableHeight();
      });
    },
  },
};
</script>
<style lang="scss">
tr:hover .btn-td-wrap {
  display: block;
}

.btn-td-wrap {
  display: none;
}
</style>
